import React from "react";
import "./UploadBtn.css"
const Upload_btn = ({
  title = "Choose File",
  bgColor = "#000",
  color = "#fff",
  onClick,
  className = "",
  style = {},
}) => {
  return (
    <button
     type="button"  
      className={`upload_btn ${className}`}
      onClick={onClick}
      style={{
        backgroundColor: bgColor,
        color: color,
        ...style,
      }}
    >
      {title}
    </button>
  );
};

export default Upload_btn;